import React from 'react';
import { observer } from 'mobx-react';
import { CampaignStore } from '@seedlang/stores';
import { isPresent } from '@seedlang/utils';
import moment from 'moment';
import { AppUI } from '@seedlang/state';
import Grid from 'components/layout/grid';
import ButtonPrimary from 'components/button/button_primary';

@observer
class CampaignCreate extends React.Component {

  onClick() {
    if (this.props.oneTimeSending || isPresent(this.refs.name.value)) {
      CampaignStore.create(
        {
          data: {
            one_time_sending: this.props.oneTimeSending,
            name: this.props.oneTimeSending ? `Email - ${moment(new Date()).format('MM/DD, h:mm A')}` : this.refs.name.value,
            campaign_type_id: this.props.campaignTypeId,
            mobileNotification: this.props.mobileNotification,
            site_id: AppUI.site.id,
          },
        },
        this.props.afterCreate,
      );
      if (!this.props.oneTimeSending) {
        this.refs.name.value = '';
      }
    }
  }

  render() {
    return (
      <Grid columns={[5, 1]} gap='sm'>
        {
          !this.props.oneTimeSending &&
              <input
                placeholder='Add a name'
                ref='name'
              />
        }
        <ButtonPrimary onClick={this.onClick.bind(this)}>
          { this.props.oneTimeSending ? 'Create an Email' : 'Create'}
        </ButtonPrimary>
      </Grid>
    );
  }
}

export default CampaignCreate;
